import { forwardRef, type ReactNode, type UIEventHandler } from 'react';

import { cardClassName } from './cardClassName';

export interface CardShellProps {
  children: ReactNode;
  className?: string;
  withPadding?: boolean;
  onScroll?: UIEventHandler<HTMLDivElement>;
}

export const CardShell = forwardRef<HTMLDivElement, CardShellProps>(
  ({ children, className, withPadding = true, onScroll }, ref) => (
    <div ref={ref} className={cardClassName(withPadding, className)} onScroll={onScroll}>
      {children}
    </div>
  ),
);
